const columnsAllVehicle = [
  {
    title: "Index",
    key: "stt",
    dataIndex: "stt",
    scopedSlots: { customRender: "stt" },
    align: "center",
    width: 50,
  },
  {
    title: "Model",
    dataIndex: "model",
    scopedSlots: { customRender: "model" },
    sorter: (a, b) => a.model.localeCompare(b.model),
  },
  {
    title: "Plate",
    dataIndex: "plate",
    scopedSlots: { customRender: "plate" },
    width: 250,
  },

  {
    title: "Seat",
    dataIndex: "seat",
  },
  {
    title: "Vehicle type",
    dataIndex: "vehicleType.model",
  },
  {
    title: "Location",
    dataIndex: "location.name",
  },
  {
    title: "Driver",
    dataIndex: "driverEmployee.fullname",
  },

  {
    title: "Created At",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

export { columnsAllVehicle };
